import { ReactNode } from "react";
//import our main package
import * as Typography from "../../Element/Typography";
//import our css
import styles from "./loader.module.css";

const { Heading } = Typography;

type LoaderProps = {
  label: string;
  variant?: "linearLeftAndRight" | "bouncingBall";
};

/**
 * This is loader component
 */
function Loader({
  label,
  // TODO CustomLoader: Pass the Animated SVG directly from the pub folder
  variant = "linearLeftAndRight",
}: LoaderProps): ReactNode {
  return (
    <div className={styles.loaderContainer}>
      <div className={styles.headingContainer}>
        <Heading.SubHeading4>{label}</Heading.SubHeading4>
      </div>

      {variant === "bouncingBall" ? (
        <div className={styles.loaderBallContainer}>
          {Array.from({ length: 5 }).map((_, k) => (
            <div key={k} style={{ animationDelay: `${0.25 * k}s` }} />
          ))}
        </div>
      ) : (
        <div className={styles.loader}>
          <div className={styles.loaderBar}></div>
        </div>
      )}
    </div>
  );
}

export default Loader;
